import 'chartjs-adapter-moment';
import moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map } from 'rxjs';
import { Brand } from '../../models/new/brand.model';
import { GraphQLService } from '../../../../services/graph-ql.service';
import { DatabaseQueries } from '../../../../shared/types/get-query';
import { MatDialog } from '@angular/material/dialog';
import { FilterListComponent } from '../../../../shared/components/filter-list/filter-list.component';
import { BrandFilterService } from 'src/app/services/filters/brand-filter.service';
import * as _ from 'lodash';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { StylePriceMapper } from '../../services/style-price-mapper';
import { StylePrice, StylePriceFilters, PriceChange } from '../../models/new/style-price';
import { StyleStatus } from '../../models/new/style';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { Category } from '../../models/new/category';
import { StyleGroup } from '../../models/new/style-group';
import { StyleDescription } from '../../models/new/style-description';
import { Collection } from '../../models/new/collection';
import { Purpose } from '../../models/new/purpose';
import { Gender } from '../../models/new/style';
import { Team } from '../../models/new/team';
import { CategoryFilterService } from 'src/app/services/filters/category-filter.service';
import { StyleGroupFilterService } from 'src/app/services/filters/style-group-filter.service';
import { StyleDescriptionFilterService } from 'src/app/services/filters/style-description-filter.service';
import { CollectionFilterService } from 'src/app/services/filters/collection-filter.service';
import { PurposeFilterService } from 'src/app/services/filters/purpose-filter.service';
import { GenderFilterService } from 'src/app/services/filters/gender-filter.service';
import { TeamFilterService } from 'src/app/services/filters/team-filter.service';
import { StringFilterListComponent } from 'src/app/shared/components/string-filter-list/string-filter-list.component';
import { IdsFilterListComponent } from 'src/app/shared/components/ids-filter-list/ids-filter-list.component';
import { Status } from '../../models/new/status';
import { OrderStatusFilterService } from 'src/app/services/filters/style-status-filter.service';
import { Paginable } from 'src/app/shared/types/paginable';
import { Selectable } from 'src/app/shared/types/selectable.type';
import { ChartConfiguration } from 'chart.js';
import { DateRange } from '../../models/new/dateRange';
import { DateFilterListComponent } from 'src/app/shared/components/date-filter-list/date-filter-list.component';

@Component({
  standalone: false,
  selector: 'bt-company-insight-style-price',
  templateUrl: './company-insight-style-price.component.html',
  styleUrls: ['./company-insight-style-price.component.scss']
})
export class CompanyInsightStylePriceComponent implements OnInit {
  loading: boolean = false;
  styles: Paginable<StylePrice> = new Paginable<StylePrice>();
  styleFilters: StylePriceFilters = new StylePriceFilters();
  styleStatus = StyleStatus;
  selectedStyles: StylePrice[] = [];
  chartConfigs = new Map<number, ChartConfiguration<'line'>>();
  private tooltipHideTimers = new Map<string, any>();

  constructor(
    private graphQlService: GraphQLService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private utilitiesService: UtilitiesService,
    private brandFilterService: BrandFilterService,
    private styleStatusFilterService: OrderStatusFilterService,
    private categoryFilterService: CategoryFilterService,
    private styleGroupFilterService: StyleGroupFilterService,
    private styleDescriptionFilterService: StyleDescriptionFilterService,
    private collectionFilterService: CollectionFilterService,
    private purposeFilterService: PurposeFilterService,
    private genderFilterService: GenderFilterService,
    private teamFilterService: TeamFilterService,
    private stylePriceMapper: StylePriceMapper,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getStyles();
  }

  getLabel(filter: string): string {
    switch (filter) {
      case 'brands':
        return this.styleFilters.brands && this.styleFilters.brands.length
          ? this.styleFilters.brands.map((b) => b.name).join(', ')
          : '';
      case 'categories':
        return this.styleFilters.categories && this.styleFilters.categories.length
          ? this.styleFilters.categories.map((c) => c.name).join(', ')
          : '';
      case 'styleGroups':
        return this.styleFilters.styleGroups && this.styleFilters.styleGroups.length
          ? this.styleFilters.styleGroups.map((sg) => sg.name).join(', ')
          : '';
      case 'styleDescriptions':
        return this.styleFilters.styleDescriptions && this.styleFilters.styleDescriptions.length
          ? this.styleFilters.styleDescriptions.map((sd) => sd.name).join(', ')
          : '';
      case 'collections':
        return this.styleFilters.collections && this.styleFilters.collections.length
          ? this.styleFilters.collections.map((c) => c.name).join(', ')
          : '';
      case 'purposes':
        return this.styleFilters.purposes && this.styleFilters.purposes.length
          ? this.styleFilters.purposes.map((p) => p.name).join(', ')
          : '';
      case 'genders':
        return this.styleFilters.genders && this.styleFilters.genders.length
          ? this.styleFilters.genders.map((g) => g.name).join(', ')
          : '';
      case 'teams':
        return this.styleFilters.teams && this.styleFilters.teams.length
          ? this.styleFilters.teams.map((t) => t.name).join(', ')
          : '';
      default:
        return '';
    }
  }

  prepareFilterOptions(params: Params) {
    if (params['brands'] && params['brands'].length)
      this.brandFilterService.searchById(params['brands']).subscribe((res: Brand[]) => {
        this.styleFilters.brands?.forEach((brand) => {
          brand.name = res.find((b) => b.id == brand.id)?.name;
        });
      });

    if (params['categories'] && params['categories'].length)
      this.categoryFilterService.searchById(params['categories']).subscribe((res: Category[]) => {
        this.styleFilters.categories?.forEach((category) => {
          category.name = res.find((c) => c.id == category.id)?.name;
        });
      });

    if (params['styleGroups'] && params['styleGroups'].length)
      this.styleGroupFilterService.searchById(params['styleGroups']).subscribe((res: StyleGroup[]) => {
        this.styleFilters.styleGroups?.forEach((styleGroup) => {
          styleGroup.name = res.find((sg) => sg.id == styleGroup.id)?.name;
        });
      });

    if (params['styleDescriptions'] && params['styleDescriptions'].length)
      this.styleDescriptionFilterService
        .searchById(params['styleDescriptions'])
        .subscribe((res: StyleDescription[]) => {
          this.styleFilters.styleDescriptions?.forEach((styleDescription) => {
            styleDescription.name = res.find((sd) => sd.id == styleDescription.id)?.name;
          });
        });

    if (params['collections'] && params['collections'].length)
      this.collectionFilterService.searchById(params['collections']).subscribe((res: Collection[]) => {
        this.styleFilters.collections?.forEach((collection) => {
          collection.name = res.find((c) => c.id == collection.id)?.name;
        });
      });

    if (params['purposes'] && params['purposes'].length)
      this.purposeFilterService.searchById(params['purposes']).subscribe((res: Purpose[]) => {
        this.styleFilters.purposes?.forEach((purpose) => {
          purpose.name = res.find((p) => p.id == purpose.id)?.name;
        });
      });

    if (params['genders'] && params['genders'].length)
      this.genderFilterService.searchById(params['genders']).subscribe((res: Gender[]) => {
        this.styleFilters.genders?.forEach((gender) => {
          gender.name = res.find((g) => g.id == gender.id)?.name;
        });
      });

    if (params['teams'] && params['teams'].length)
      this.teamFilterService.searchById(params['teams']).subscribe((res: Team[]) => {
        this.styleFilters.teams?.forEach((team) => {
          team.name = res.find((t) => t.id == team.id)?.name;
        });
      });
  }

  pageEvent(event: { pageNumber: number; pageSize: number }) {
    this.styles.currentPage = event.pageNumber;
    this.styles.size = event.pageSize;

    this.styleFilters.page = event.pageNumber;
    this.styleFilters.size = event.pageSize;

    this.refreshNavigation(false);
  }

  setDateUtils(type: number) {
    switch (type) {
      case 1:
        this.styleFilters.dateRange = {
          from: moment().startOf('year').toDate(),
          to: moment().endOf('year').toDate()
        };
        break;
      case 2:
        this.styleFilters.dateRange = {
          from: moment().subtract(1, 'year').startOf('year').toDate(),
          to: moment().subtract(1, 'year').endOf('year').toDate()
        };
        break;
      case 3:
        this.styleFilters.dateRange = {
          from: moment().startOf('month').toDate(),
          to: moment().endOf('month').toDate()
        };
        break;
      case 4:
        this.styleFilters.dateRange = {
          from: moment().subtract(1, 'month').startOf('month').toDate(),
          to: moment().subtract(1, 'month').endOf('month').toDate()
        };
        break;
    }

    this.refreshNavigation();
  }

  getStyles() {
    this.loading = true;

    this.route.queryParams.subscribe((params: Params) => {
      if (!params['dateFrom'] && !params['dateTo']) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            dateFrom: moment().startOf('year').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            page: 1,
            size: 20
          },
          replaceUrl: true
        });
        return;
      }

      this.styleFilters = this.stylePriceMapper.urlToFilters(params);

      this.prepareFilterOptions(params);

      this.styles.currentPage = this.styleFilters.page || 1;
      this.styles.size = this.styleFilters.size || 20;

      const pagination = this.styles.buildQuery(this.styles.currentPage);

      this.graphQlService
        .getData<any>(DatabaseQueries.GET_STYLES_PRICES, {
          startDate: this.styleFilters.dateRange?.from
            ? moment(this.styleFilters.dateRange.from).format('YYYY-MM-DD')
            : undefined,
          endDate: this.styleFilters.dateRange?.to
            ? moment(this.styleFilters.dateRange.to).format('YYYY-MM-DD')
            : undefined,
          where: this.stylePriceMapper.toWhereClause(this.styleFilters),
          ...pagination
        })
        .pipe(
          map((res: any) => {
            const stylesCost = res.data.stylesCost;

            const paginable = new Paginable<StylePrice>({
              items: stylesCost.nodes.map((node: any) => this.stylePriceMapper.toStylePrice(node)),
              totalCount: stylesCost.totalCount,
              currentPage: this.styles.currentPage,
              size: this.styles.size
            });

            return paginable;
          })
        )
        .subscribe({
          next: (data: Paginable<StylePrice>) => {
            this.chartConfigs.clear();
            data.items.forEach((item) => {
              if (item.modelId != null) {
                this.chartConfigs.set(item.modelId, this.getPriceChartConfig(item));
              }
            });
            this.styles = data;
            this.loading = false;
          },
          error: (err) => {
            this.utilitiesService.showSnackbar('Error fetching styles', SnackbarType.Error);
            this.loading = false;
            console.error(err);
          }
        });
    });
  }

  isSelected(modelId: number): boolean {
    return this.selectedStyles.some((s) => s.modelId == modelId);
  }

  // Cambiando periodo o filtri si riparte dalla prima pagina: restando su una pagina successiva
  // un risultato più corto appariva vuoto ("No styles found"). Solo la paginazione tiene la pagina.
  refreshNavigation(resetPage = true) {
    this.loading = true;

    if (resetPage) {
      this.styleFilters.page = 1;
    }

    // Con gli stessi filtri l'URL non cambia: il router ignora la navigazione (risolve false), queryParams
    // non emette e la lista non si ricarica, quindi il loader va spento qui.
    this.router
      .navigate([location.pathname], {
        queryParams: this.stylePriceMapper.filtersToUrl(this.styleFilters)
      })
      .then((navigated) => {
        if (!navigated) {
          this.loading = false;
        }
      });
  }

  selectStyle(style: StylePrice) {
    if (this.isSelected(style.modelId!)) {
      this.selectedStyles = this.selectedStyles.filter((s) => s.modelId !== style.modelId);
    } else {
      this.selectedStyles.push(style);
    }
  }

  deselectAll() {
    this.selectedStyles = [];
  }

  cleanFilter(filter: string) {
    switch (filter) {
      case 'brands':
        this.styleFilters.brands = [];
        break;
      case 'categories':
        this.styleFilters.categories = [];
        break;
      case 'styleGroups':
        this.styleFilters.styleGroups = [];
        break;
      case 'styleDescriptions':
        this.styleFilters.styleDescriptions = [];
        break;
      case 'collections':
        this.styleFilters.collections = [];
        break;
      case 'purposes':
        this.styleFilters.purposes = [];
        break;
      case 'genders':
        this.styleFilters.genders = [];
        break;
      case 'teams':
        this.styleFilters.teams = [];
        break;
      case 'styleCode':
        this.styleFilters.styleCode = '';
        break;
      case 'orderIds':
        this.styleFilters.orderIds = undefined;
        break;
      case 'basicNetIds':
        this.styleFilters.basicNetIds = undefined;
        break;

      default:
        break;
    }

    this.styleFilters.page = 1;

    this.refreshNavigation();
  }

  openStyleCodesFilter() {
    this.dialog
      .open(StringFilterListComponent, {
        data: { title: 'Style Code', selected: this.styleFilters.styleCode }
      })
      .afterClosed()
      .subscribe({
        next: (res) => {
          if (res) {
            this.styleFilters.styleCode = _.cloneDeep(res);

            this.refreshNavigation();
          }
        }
      });
  }

  openOrderIdsFilter() {
    this.dialog
      .open(IdsFilterListComponent, {
        data: { title: 'Order id', selected: this.styleFilters.orderIds }
      })
      .afterClosed()
      .subscribe({
        next: (res) => {
          if (res) {
            this.styleFilters.orderIds = res;
            this.styleFilters.page = 1;
            this.refreshNavigation();
          }
        }
      });
  }

  openBasicNetIdsFilter() {
    this.dialog
      .open(IdsFilterListComponent, {
        data: { title: 'BasicNet ID', selected: this.styleFilters.basicNetIds }
      })
      .afterClosed()
      .subscribe({
        next: (res) => {
          if (res) {
            this.styleFilters.basicNetIds = res;
            this.styleFilters.page = 1;
            this.refreshNavigation();
          }
        }
      });
  }

  openDateRangeFilterModal() {
    this.dialog
      .open(DateFilterListComponent, {
        data: {
          title: 'Date Range',
          selected: _.cloneDeep(this.styleFilters.dateRange)
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: DateRange) => {
          if (res) {
            this.styleFilters.dateRange = res;
            this.refreshNavigation();
          }
        }
      });
  }

  openStatusFilterModal(): void {
    this.dialog
      .open(FilterListComponent<Status>, {
        data: {
          title: 'Statuses',
          selected: this.styleFilters.statuses
            ? this.styleFilters.statuses.map((el) => ({
                ...el,
                displayId: el.id,
                displayName: el.name,
                selected: true
              }))
            : [],
          filterService: this.styleStatusFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Status>>) => {
          if (res) {
            this.styleFilters.statuses = res.map((el: any) => new Status({ id: el.displayId, name: el.displayName }));
            this.refreshNavigation();
          }
        }
      });
  }

  openBrandFilterModal(): void {
    this.dialog
      .open(FilterListComponent<Brand>, {
        data: {
          title: 'Brands',
          selected: this.styleFilters.brands
            ? this.styleFilters.brands.map((el) => ({
                ...el,
                displayId: el.id,
                displayName: el.name,
                selected: true
              }))
            : [],
          filterService: this.brandFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Brand>>) => {
          if (res) {
            this.styleFilters.brands = res.map((el: any) => new Brand({ id: el.displayId, name: el.displayName }));

            this.refreshNavigation();
          }
        }
      });
  }

  openCategoryFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Categories',
          selected:
            this.styleFilters.categories?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.categoryFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Category>>) => {
          if (res) {
            this.styleFilters.categories = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
            this.refreshNavigation();
          }
        }
      });
  }

  openStyleGroupFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Style Groups',
          selected:
            this.styleFilters.styleGroups?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.styleGroupFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<StyleGroup>>) => {
          if (res) {
            this.styleFilters.styleGroups = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
            this.refreshNavigation();
          }
        }
      });
  }

  openStyleDescriptionFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Style Descriptions',
          selected:
            this.styleFilters.styleDescriptions?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.styleDescriptionFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<StyleDescription>>) => {
          if (res) {
            this.styleFilters.styleDescriptions = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
            this.refreshNavigation();
          }
        }
      });
  }

  openCollectionFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Collections',
          selected:
            this.styleFilters.collections?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.collectionFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Collection>>) => {
          if (res) {
            this.styleFilters.collections = res.map((el: any) => ({
              id: el.displayId,
              name: el.displayName,
              startDate: el.startDate,
              endDate: el.endDate
            }));
            this.refreshNavigation();
          }
        }
      });
  }

  openPurposeFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Purposes',
          selected:
            this.styleFilters.purposes?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.purposeFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Purpose>>) => {
          if (res) {
            this.styleFilters.purposes = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
            this.refreshNavigation();
          }
        }
      });
  }

  openGenderFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Genders',
          selected:
            this.styleFilters.genders?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.genderFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Gender>>) => {
          if (res) {
            this.styleFilters.genders = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
            this.refreshNavigation();
          }
        }
      });
  }

  openTeamFilterModal(): void {
    this.dialog
      .open(FilterListComponent, {
        data: {
          title: 'Teams',
          selected:
            this.styleFilters.teams?.map((el) => ({
              ...el,
              displayId: el.id,
              displayName: el.name,
              selected: true
            })) || [],
          filterService: this.teamFilterService
        },
        width: '400px'
      })
      .afterClosed()
      .subscribe({
        next: (res: Array<Selectable<Team>>) => {
          if (res) {
            this.styleFilters.teams = res.map((el: any) => ({ id: el.displayId, name: el.displayName, code: el.code }));
            this.refreshNavigation();
          }
        }
      });
  }

  private externalTooltipHandler(context: any): void {
    const { chart, tooltip } = context;
    const tooltipId = 'chartjs-tooltip-' + chart.canvas.id;

    let el = document.getElementById(tooltipId);
    if (!el) {
      el = document.createElement('div');
      el.id = tooltipId;
      el.style.cssText =
        'position:absolute;background:#fff;border:1px solid #ddd;border-radius:4px;padding:8px 10px;pointer-events:auto;font-size:12px;box-shadow:0 2px 6px rgba(0,0,0,.15);z-index:9999;min-width:180px;line-height:1.6;transition:opacity .1s';
      el.addEventListener('mouseenter', () => {
        clearTimeout(this.tooltipHideTimers.get(tooltipId));
        el!.style.opacity = '1';
      });
      el.addEventListener('mouseleave', () => {
        this.tooltipHideTimers.set(
          tooltipId,
          setTimeout(() => {
            el!.style.opacity = '0';
          }, 150)
        );
      });
      document.body.appendChild(el);
    }

    if (tooltip.opacity === 0) {
      this.tooltipHideTimers.set(
        tooltipId,
        setTimeout(() => {
          el!.style.opacity = '0';
        }, 200)
      );
      return;
    }

    clearTimeout(this.tooltipHideTimers.get(tooltipId));

    const dp = tooltip.dataPoints?.find((p: any) => p.datasetIndex === 0);
    if (dp) {
      const raw = dp.raw as any;
      const price = raw.y != null ? raw.y.toFixed(2) : '-';
      const orderId = raw.orderId;
      const date = raw.orderCreationDate
        ? new Date(raw.orderCreationDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          })
        : '-';
      const orderUrl = `/company/order-view/${orderId}/order-detail-shots`;

      el.innerHTML =
        `<div><b>Price:</b> ${price}€</div>` +
        (orderId
          ? `<div><b>Order:</b> <a href="${orderUrl}" target="_blank" style="color:#1976d2">${orderId}</a></div>`
          : '') +
        `<div><b>Date:</b> ${date}</div>`;
    }

    const rect = chart.canvas.getBoundingClientRect();
    el.style.opacity = '1';
    el.style.left = rect.left + window.scrollX + tooltip.caretX + 12 + 'px';
    el.style.top = rect.top + window.scrollY + tooltip.caretY - 20 + 'px';
  }

  getPriceChartConfig(style: StylePrice): ChartConfiguration<'line'> {
    const startDate = this.styleFilters.dateRange?.from;
    const endDate = this.styleFilters.dateRange?.to;

    const sortedChanges = (style.priceChanges || [])
      .slice()
      .sort((a, b) => new Date(a.orderCreationDate!).getTime() - new Date(b.orderCreationDate!).getTime());

    const chartData = sortedChanges.map((pc) => ({
      x: new Date(pc.orderCreationDate!).getTime(),
      y: pc.price ?? 0,
      orderId: pc.orderId,
      orderCreationDate: pc.orderCreationDate
    })) as any[];

    const avg = style.periodAverage ?? 0;

    // L'asse orizzontale segue gli ordini del modello, non tutto il periodo selezionato: con un periodo
    // lungo e pochi ordini il grafico restava quasi vuoto. Un piccolo margine tiene i punti lontani dai bordi;
    // con un solo ordine (o tutti nello stesso giorno) si apre una finestra di qualche giorno intorno.
    const DAY = 24 * 60 * 60 * 1000;
    const firstOrder = chartData.length ? chartData[0].x : startDate?.getTime() || 0;
    const lastOrder = chartData.length ? chartData[chartData.length - 1].x : endDate?.getTime() || 0;
    const margin = Math.max((lastOrder - firstOrder) * 0.03, 3 * DAY);
    const xMin = firstOrder - margin;
    const xMax = lastOrder + margin;

    return {
      type: 'line',
      data: {
        datasets: [
          {
            label: 'Price',
            data: chartData,
            borderColor: '#1976d2',
            backgroundColor: 'rgba(140, 193, 245, 0.25)',
            fill: true,
            tension: 0.1,
            pointRadius: 3,
            pointHoverRadius: 4,

            pointBackgroundColor: '#1976d2',
            pointHoverBackgroundColor: '#ff0000',
            borderWidth: 1
          },
          {
            label: 'Average',
            data: [
              { x: xMin, y: avg },
              { x: xMax, y: avg }
            ],
            borderColor: '#e53935',
            backgroundColor: 'transparent',
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            borderWidth: 1,
            borderDash: [5, 4]
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: 0
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false,
            external: this.externalTooltipHandler.bind(this)
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            suggestedMax: 100,
            title: {
              display: false
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)',
              drawTicks: false
            },
            ticks: {
              font: { size: 10 },
              maxTicksLimit: 3
            }
          },
          x: {
            type: 'time',
            title: {
              display: false
            },
            grid: {
              display: false
            },
            min: xMin,
            max: xMax,
            time: {
              unit: 'month',
              displayFormats: { month: 'MMM dd' }
            },
            ticks: {
              display: false
            }
          }
        }
      }
    };
  }
}
